// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

// shopping cart
frappe.provide("webshop.webshop.shopping_cart");
var shopping_cart = webshop.webshop.shopping_cart;

var getParams = function (url) {
	var params = [];
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

frappe.ready(function () {
	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if (full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code = frappe.get_cookie("referral_coupon_code");
	referral_sales_partner = frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val() == undefined) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}

	// update login
	shopping_cart.show_shoppingcart_dropdown();
	shopping_cart.set_cart_count();
	shopping_cart.show_cart_navbar();
	shopping_cart.bind_cart_sidebar_trigger();
	shopping_cart.bind_cart_sidebar_actions();
});

$.extend(shopping_cart, {
	sync_preferred_addresses_to_cart() {
		frappe.call({
			type: "POST",
			method: "klaviyo_integration.www.cart.index.sync_preferred_addresses_to_cart",
			callback: function (r) {
				if (r.message && r.message.updated) {
					shopping_cart.refresh_cart_sidebar();
				}
			}
		});
	},

	show_shoppingcart_dropdown: function () {
		$(".shopping-cart").on('shown.bs.dropdown', function () {
			if (!$('.shopping-cart-menu .cart-container').length) {
				return frappe.call({
					method: 'webshop.webshop.shopping_cart.cart.get_shopping_cart_menu',
					callback: function (r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	update_cart: function (opts) {
		if (frappe.session.user === "Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
				window.location.href = res.message || "/login";
			});
		} else {
			shopping_cart.freeze();
			return frappe.call({
				type: "POST",
				method: "webshop.webshop.shopping_cart.cart.update_cart",
				args: {
					item_code: opts.item_code,
					qty: opts.qty,
					additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
					with_items: opts.with_items || 0,
					design_form_index: opts.design_form_index || 0
				},
				btn: opts.btn,
				callback: function (r) {
					shopping_cart.unfreeze();
					shopping_cart.set_cart_count(true);
					if (opts.callback)
						opts.callback(r);
				}
			});
		}
	},

	set_cart_count: function (animate = false) {
		$(".intermediate-empty-cart").remove();

		var cart_count = frappe.get_cookie("cart_count");
		if (frappe.session.user === "Guest") {
			cart_count = 0;
		}

		if (cart_count) {
			$(".shopping-cart").toggleClass('hidden', false);
		}

		var $cart = $('.cart-icon');
		var $badge = $cart.find(".js-cart-count");

		if (parseInt(cart_count) === 0 || cart_count === undefined) {
			$cart.css("display", "inline");
			$(".cart-tax-items").hide();
			$(".btn-place-order").hide();
			$(".cart-payment-addresses").hide();

			let intermediate_empty_cart_msg = `
				<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
					${__("Cart is Empty")}
				</div>
			`;
			$(".cart-table").after(intermediate_empty_cart_msg);
		}
		else {
			$cart.css("display", "inline");
			$badge.text(cart_count);
		}

		if (cart_count) {
			$badge.html(cart_count);

			if (animate) {
				$cart.addClass("cart-animate");
				setTimeout(() => {
					$cart.removeClass("cart-animate");
				}, 500);
			}
		} else {
			$badge.text("");
		}
	},

	shopping_cart_update: function ({ item_code, qty, cart_dropdown, additional_notes }) {
		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			with_items: 1,
			btn: this,
			callback: function (r) {
				if (!r.exc) {
					$(".cart-items").html(r.message.items);
					$(".cart-tax-items").html(r.message.total);
					$(".payment-summary").html(r.message.taxes_and_totals);
					shopping_cart.set_cart_count();

					if (cart_dropdown != true) {
						$(".cart-icon").hide();
					}
				}
			},
		});
	},

	show_cart_navbar: function () {
		frappe.call({
			method: "webshop.webshop.doctype.webshop_settings.webshop_settings.is_cart_enabled",
			callback: function (r) {
				$(".shopping-cart").toggleClass('hidden', r.message ? false : true);
			}
		});
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	bind_add_to_cart_action() {
		$('.page_content').on('click', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);
			$btn.prop('disabled', true);

			if (frappe.session.user === "Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('webshop.webshop.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			$btn.addClass('hidden');
			$btn.closest('.cart-action-container').addClass('d-flex');
			$btn.parent().find('.go-to-cart').removeClass('hidden');
			$btn.parent().find('.go-to-cart-grid').removeClass('hidden');
			$btn.parent().find('.cart-indicator').removeClass('hidden');

			const item_code = $btn.data('item-code');
			webshop.webshop.shopping_cart.update_cart({
				item_code,
				qty: 1
			});

		});
	},

	freeze() {
		if (window.location.pathname !== "/cart") return;

		if (!$('#freeze').length) {
			let freeze = $('<div id="freeze" class="modal-backdrop fade"></div>')
				.appendTo("body");

			setTimeout(function () {
				freeze.addClass("show");
			}, 1);
		} else {
			$("#freeze").addClass("show");
		}
	},

	unfreeze() {
		if ($('#freeze').length) {
			let freeze = $('#freeze').removeClass("show");
			setTimeout(function () {
				freeze.remove();
			}, 1);
		}
	},

	show_custom_confirm(title, message, buttons) {
		return new Promise((resolve) => {
			const overlay = document.createElement('div');
			overlay.className = 'confirm-modal-overlay';

			const modal = document.createElement('div');
			modal.className = 'confirm-modal';

			const titleEl = document.createElement('div');
			titleEl.className = 'confirm-modal-title';
			titleEl.textContent = title;

			const closeBtn = document.createElement('button');
			closeBtn.className = 'confirm-modal-close';
			closeBtn.innerHTML = '&times;';
			closeBtn.onclick = () => {
				overlay.classList.remove('show');
				setTimeout(() => overlay.remove(), 300);
				resolve(null);
			};

			const bodyEl = document.createElement('div');
			bodyEl.className = 'confirm-modal-body';
			bodyEl.innerHTML = message;

			const actionsEl = document.createElement('div');
			actionsEl.className = 'confirm-modal-actions';

			buttons.forEach(btn => {
				const btnEl = document.createElement('button');
				btnEl.className = btn.primary ? 'primary-btn' : 'secondary-btn';
				btnEl.textContent = btn.text;
				btnEl.onclick = () => {
					overlay.classList.remove('show');
					setTimeout(() => overlay.remove(), 300);
					resolve(btn.value);
				};
				actionsEl.appendChild(btnEl);
			});

			modal.appendChild(closeBtn);
			modal.appendChild(titleEl);
			modal.appendChild(bodyEl);
			modal.appendChild(actionsEl);

			overlay.onclick = (e) => {
				if (e.target === overlay) {
					overlay.classList.remove('show');
					setTimeout(() => overlay.remove(), 300);
					resolve(null);
				}
			};

			overlay.appendChild(modal);
			document.body.appendChild(overlay);

			void overlay.offsetWidth;
			overlay.classList.add('show');
		});
	},

	bind_cart_sidebar_trigger() {
		$(document).on("click", "[data-cart-sidebar-trigger]", function (e) {
			e.preventDefault();
			shopping_cart.open_cart_sidebar(this);
		});

		// Mobile Safari can occasionally navigate before delegated handlers run.
		// Capture clicks early for mobile cart icons and force drawer behavior.
		if (!shopping_cart._mobile_cart_trigger_bound) {
			document.addEventListener("click", function (e) {
				const trigger = e.target.closest(".mobile-navbar-cart, .drawer-action[data-cart-sidebar-trigger]");
				if (!trigger) return;

				if (window.matchMedia && !window.matchMedia("(max-width: 991.98px)").matches) {
					return;
				}

				e.preventDefault();
				e.stopPropagation();
				shopping_cart.open_cart_sidebar(trigger);
			}, true);
			shopping_cart._mobile_cart_trigger_bound = true;
		}

		if (!shopping_cart._cart_open_listener_bound) {
			document.addEventListener("cart:open", function () {
				const trigger = document.querySelector("[data-cart-sidebar-trigger]");
				shopping_cart.open_cart_sidebar(trigger || null);
			});
			shopping_cart._cart_open_listener_bound = true;
		}

		$(document).on("click", "#cart-drawer-backdrop, .js-close-cart-drawer", function () {
			shopping_cart.close_cart_sidebar();
		});

		$(document).on("keydown", function (e) {
			if (e.key === "Escape" && $("body").hasClass("cart-drawer-open")) {
				shopping_cart.close_cart_sidebar();
			}
		});

		// Enter / Shift+Enter in sidebar design textareas → newline, never submit
		$(document).on("keydown", ".sidebar-design-a-input, .ds-simple-instructions-input", function (e) {
			if (e.key === "Enter" && !e.isDefaultPrevented()) {
				e.preventDefault();
				const ta = this;
				const start = ta.selectionStart;
				const end = ta.selectionEnd;
				ta.value = ta.value.slice(0, start) + "\n" + ta.value.slice(end);
				ta.selectionStart = ta.selectionEnd = start + 1;
				$(ta).trigger("input");
			}
		});
	},

	bind_cart_sidebar_actions() {

		$(document).on("change", ".js-sidebar-cart-select", function () {
			const quotationName = (($(this).val() || "") + "").trim();
			if (!quotationName) return;
			shopping_cart.sidebar_switch_cart(quotationName);
		});

		$(document).on("click", ".js-sidebar-cart-add", function () {
			const name = window.prompt(__("New cart name"), "");
			if (name === null) return;
			shopping_cart.sidebar_create_cart((name || "").trim());
		});

		$(document).on("click", ".js-sidebar-cart-rename", function () {
			const active = shopping_cart.get_active_sidebar_cart_name();
			if (!active) return;

			const currentLabel = (($(".js-sidebar-cart-select option:selected").data("label") || "") + "").trim();
			const nextLabel = window.prompt(__("Rename cart"), currentLabel);
			if (nextLabel === null) return;

			shopping_cart.sidebar_rename_cart(active, (nextLabel || "").trim());
		});

		$(document).on("click", ".js-sidebar-cart-delete", async function () {
			const active = shopping_cart.get_active_sidebar_cart_name();
			if (!active) return;

			const confirmed = await shopping_cart.show_custom_confirm(
				__("Delete Cart"),
				__("Delete selected cart?"),
				[
					{ text: __("Cancel"), value: false, primary: false },
					{ text: __("Delete"), value: true, primary: true }
				]
			);
			if (!confirmed) return;
			shopping_cart.sidebar_delete_cart(active);
		});

		// Design accordion toggle
		$(document).off("click.cartAccordion").on("click.cartAccordion", ".sidebar-design-accordion-header", function (e) {
			e.preventDefault();
			e.stopPropagation();
			const $header = $(this);
			const $body = $header.closest(".sidebar-design-accordion-header-row").next(".sidebar-design-accordion-body");
			const isOpen = $header.hasClass("active");

			if (isOpen) {
				$body.slideUp(300);
				$header.removeClass("active").attr("aria-expanded", "false");
			} else {
				$body.slideDown(300);
				$header.addClass("active").attr("aria-expanded", "true");
			}
		});

		// Design edit cancel
		$(document).on("click", ".sidebar-design-cancel-btn", function () {
			const $accordion = $(this).closest(".sidebar-design-accordion");
			$accordion.find(".sidebar-design-inline-form").hide();
			$accordion.find(".sidebar-design-view-mode").show();
		});

		// Design edit remove file
		$(document).on("click", ".sidebar-design-edit-file-remove", function () {
			$(this).closest(".sidebar-design-edit-file").remove();
		});

		// Design edit upload file
		$(document).on("click", ".sidebar-design-upload-btn", function () {
			const $btn = $(this);
			const $fileList = $btn.siblings(".sidebar-design-edit-file-list");

			const input = document.createElement("input");
			input.type = "file";
			input.multiple = true;
			input.accept = "image/*,.pdf,.ai,.eps,.svg,.psd,.zip";
			input.onchange = function () {
				if (!input.files || !input.files.length) return;

				Array.from(input.files).forEach(function (file) {
					const formData = new FormData();
					formData.append("file", file);
					formData.append("is_private", "0");
					formData.append("folder", "Home/Attachments");

					$.ajax({
						url: "/api/method/upload_file",
						type: "POST",
						data: formData,
						processData: false,
						contentType: false,
						headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
						success: function (r) {
							const url = r.message && r.message.file_url;
							if (!url) return;
							const fname = url.split("/").pop();
							$fileList.append(`
                                <div class="sidebar-design-edit-file" data-url="${url}">
                                    <span class="sidebar-design-edit-file-name" title="${fname}">${fname}</span>
                                    <button type="button" class="sidebar-design-edit-file-remove" data-url="${url}" title="Remove">&times;</button>
                                </div>
                            `);
						},
						error: function () {
							frappe.msgprint(__("Failed to upload file: " + file.name));
						}
					});
				});
			};
			input.click();
		});

		// Design edit save
		$(document).on("click", ".sidebar-design-save-btn", function () {
			const $btn = $(this);
			const $accordion = $btn.closest(".sidebar-design-accordion");
			const responseName = $accordion.data("response-name") || '';
			const rootItemCode = $accordion.data("item-code") || $btn.data("item-code");

			// Get design form index from: accordion body > button attribute > 0
			const designFormIndex = parseInt(
				$accordion.find(".sidebar-design-accordion-body").data("design-form-index")
				|| $btn.data("design-form-index")
				|| $btn.closest(".sidebar-design-accordion-body").data("design-form-index")
				|| 0,
			10);

			if (!rootItemCode) {
				frappe.msgprint(__("Cannot save — missing reference."));
				return;
			}

			const itemsData = [];
			const $groups = $btn.closest(".sidebar-design-accordion-body").find(".sidebar-design-item-edit-group");
			
			// Get simple mode state
			let isSimpleMode = 1;
			const $toggle = $btn.closest(".sidebar-design-accordion-body").find(".cart-simple-mode-toggle-checkbox");
			if ($toggle.length) {
				isSimpleMode = $toggle.is(":checked") ? 0 : 1;
			}

			if ($groups.length > 0) {
				// Multi-item bundle mode
				$groups.each(function () {
					const $group = $(this);
					const itemCode = $group.data("item-code");
					if (!itemCode) return;

					let simpleInstructions = "";
					const $simpleInput = $group.find(".ds-simple-instructions-input");
					if ($simpleInput.length) {
						simpleInstructions = $simpleInput.val().trim();
					}

					const qaList = [];
					$group.find(".sidebar-design-qa-edit").each(function () {
						const $row = $(this);
						const $input = $row.find(".sidebar-design-a-input");
						if ($input.length) {
							qaList.push({
								question: $input.data("question"),
								answer: $input.val().trim()
							});
						} else {
							const $link = $row.find(".sidebar-design-attach-link");
							const qText = $link.length ? $link.attr("href") : $row.find(".sidebar-design-q-label").text().trim();
							if (qText) {
								qaList.push({ question: qText, answer: "" });
							}
						}
					});

					$group.find('.ds-question-input:not(.ds-element-note-input)').each(function () {
						const $ta = $(this);
						const $row = $ta.closest('.ds-question-row');
						const qTitle = $row.length ? ($row.find('.ds-question-title').text() || '').trim() : '';
						if (qTitle) {
							qaList.push({
								question: qTitle,
								answer: $ta.val().trim()
							});
						}
					});

					$group.find('.ds-element-note-input').each(function () {
						const $ta = $(this);
						const elementName = ($ta.data("element-name") || 'Design Element').trim();
						qaList.push({
							question: `Design Element: ${elementName}`,
							answer: $ta.val().trim()
						});
					});

					const attachments = [];
					$group.find(".sidebar-design-edit-file").each(function () {
						const url = $(this).data("url");
						if (url) attachments.push(url);
					});
					$group.find(".ds-upload-preview-item").each(function () {
						const url = $(this).data("file-url");
						if (url) attachments.push(url);
					});

					itemsData.push({
						item_code: itemCode,
						item_name: $group.attr("data-item-name") || itemCode,
						item_group: $group.attr("data-item-group") || "",
						parent_item_code: itemCode === rootItemCode ? "" : rootItemCode,
						design_form_index: designFormIndex,
						is_simple_mode: isSimpleMode,
						simple_instructions: simpleInstructions,
						questions_answers: qaList,
						attachments: attachments
					});
				});

				// Ensure root item is always included even if skipped in artwork mode UI
				if (!itemsData.find(d => d.item_code === rootItemCode)) {
					const rootItemName = $btn.closest(".sidebar-cart-item").find(".sidebar-cart-item-name").text().trim().replace(/Design #\d+/, '').trim() || rootItemCode;
					itemsData.unshift({
						item_code: rootItemCode,
						item_name: rootItemName,
						item_group: "",
						parent_item_code: "",
						design_form_index: designFormIndex,
						is_simple_mode: isSimpleMode,
						simple_instructions: "",
						questions_answers: [],
						attachments: []
					});
				}
			} else {
				// Legacy single-item mode fallback
				const qaList = [];
				$btn.closest(".sidebar-design-accordion-body").find(".sidebar-design-qa-edit").each(function () {
					const $row = $(this);
					const $input = $row.find(".sidebar-design-a-input");
					if ($input.length) {
						qaList.push({
							question: $input.data("question"),
							answer: $input.val().trim()
						});
					} else {
						const $link = $row.find(".sidebar-design-attach-link");
						const qText = $link.length ? $link.attr("href") : $row.find(".sidebar-design-q-label").text().trim();
						if (qText) {
							qaList.push({ question: qText, answer: "" });
						}
					}
				});

				$btn.closest(".sidebar-design-accordion-body").find('.ds-question-input:not(.ds-element-note-input)').each(function () {
					const $ta = $(this);
					const $row = $ta.closest('.ds-question-row');
					const qTitle = $row.length ? ($row.find('.ds-question-title').text() || '').trim() : '';
					if (qTitle) {
						qaList.push({
							question: qTitle,
							answer: $ta.val().trim()
						});
					}
				});

				$btn.closest(".sidebar-design-accordion-body").find('.ds-element-note-input').each(function () {
					const $ta = $(this);
					const elementName = ($ta.data("element-name") || 'Design Element').trim();
					qaList.push({
						question: `Design Element: ${elementName}`,
						answer: $ta.val().trim()
					});
				});

				const attachments = [];
				$btn.closest(".sidebar-design-accordion-body").find(".sidebar-design-edit-file").each(function () {
					const url = $(this).data("url");
					if (url) attachments.push(url);
				});
				$btn.closest(".sidebar-design-accordion-body").find(".ds-upload-preview-item").each(function () {
					const url = $(this).data("file-url");
					if (url) attachments.push(url);
				});

				const rootItemName = $btn.closest(".sidebar-cart-item").find(".sidebar-cart-item-name").text().trim().replace(/Design #\d+/, '').trim() || rootItemCode;

				let simpleInstructions = "";
				const $simpleInput = $btn.closest(".sidebar-design-accordion-body").find(".ds-simple-instructions-input");
				if ($simpleInput.length) {
					simpleInstructions = $simpleInput.val().trim();
				}

				itemsData.push({
					item_code: rootItemCode,
					item_name: rootItemName,
					item_group: "",
					parent_item_code: "",
					design_form_index: designFormIndex,
					is_simple_mode: isSimpleMode,
					simple_instructions: simpleInstructions,
					questions_answers: qaList,
					attachments: attachments
				});
			}

			$btn.prop("disabled", true).text("Saving...");

			frappe.call({
				method: "klaviyo_integration.www.design_form.index.update_design_response_from_cart",
				args: {
					response_name: responseName,
					new_item_code: rootItemCode,
					items_data: JSON.stringify(itemsData),
					design_mode: window._designSidebar ? window._designSidebar.mode : 'basic_design'
				},
				callback: function (r) {
					if (r.message && r.message.status === "success") {
						frappe.show_alert({ message: __("Design details updated"), indicator: "green" }, 3);
						shopping_cart.refresh_cart_sidebar();
					}
				},
				error: function () {
					$btn.prop("disabled", false).text("Save");
				}
			});
		});

		// Inline Fill Design Form (Matches Edit UI)
		$(document).on("click", ".js-open-cart-design-form, .sidebar-design-edit-btn", function (e) {
			const $btn = $(this);
			if ($btn.hasClass("sidebar-design-edit-btn")) {
				e.stopPropagation();
			}
			const itemCode = $btn.data("item-code");
			const isEdit = $btn.hasClass("sidebar-design-edit-btn");
			const $accordionBody = isEdit 
				? $btn.closest(".sidebar-design-accordion").find(".sidebar-design-accordion-body")
				: $btn.closest(".sidebar-design-accordion-body");

			if (isEdit && !$accordionBody.is(":visible")) {
				$accordionBody.stop(true, true).slideDown(500);
				$btn.closest(".sidebar-design-accordion").find(".sidebar-design-accordion-header").addClass("active").attr("aria-expanded", "true");
			}

			const $container = $accordionBody.find(".sidebar-design-inline-form");
			const $emptyState = $accordionBody.find(".sidebar-design-empty");
			const $viewMode = $accordionBody.find(".sidebar-design-view-mode");

			if (isEdit) {
				$viewMode.hide();
			}

			if (!itemCode || !$container.length) return;

			let existingDesign = null;
			if (isEdit) {
				try {
					const jsonStr = $accordionBody.find(".existing-design-data").text();
					if (jsonStr) existingDesign = JSON.parse(jsonStr);
				} catch(err) {}
			}

			if (!isEdit) {
				$btn.prop("disabled", true).text("Loading form...");
			}

			frappe.call({
				method: "klaviyo_integration.www.product.index.get_design_sidebar_data",
				args: { item_code: itemCode },
				callback: function (r) {
					if (r.message) {
						const data = r.message;

						// Collect all items
						const allItems = [];
						// Root Item
						allItems.push(data);

						// Bundle Items
						if (data.bundle_items && data.bundle_items.length > 0) {
							if (window.DesignSidebarApi && typeof window.DesignSidebarApi.flattenBundleItems === 'function') {
								const flatBundles = window.DesignSidebarApi.flattenBundleItems(data.bundle_items).filter(b => !(window.DesignSidebarApi.isHiddenInDesignForm && window.DesignSidebarApi.isHiddenInDesignForm(b)));
								allItems.push(...flatBundles);
							} else {
								allItems.push(...data.bundle_items);
							}
						}

						const validArtworkItems = allItems.filter((item, idx) => {
							const hasTemplates = (item.product_templates && item.product_templates.length > 0) || (item.downloadable_templates && item.downloadable_templates.length > 0);
							return !(idx === 0 && item.item_code !== 'VP' && !hasTemplates);
						});

						// Add simple mode check
						window._designFormSimpleModes = window._designFormSimpleModes || {};
						if (window.SAVED_DESIGN_RESPONSES) {
						  for (const key in window.SAVED_DESIGN_RESPONSES) {
							const resp = window.SAVED_DESIGN_RESPONSES[key];
							if (resp) {
							  const ic = resp.item_code || key.split('_')[0];
							  if (window._designFormSimpleModes[ic] === undefined) {
								window._designFormSimpleModes[ic] = resp.hasOwnProperty('is_simple_mode') ? !!resp.is_simple_mode : true;
							  }
							}
						  }
						}
						
						const fillDesignFormIndexCheck = parseInt($btn.data("design-form-index") || 0, 10);
						if (existingDesign && existingDesign.all_items && existingDesign.all_items.length) {
							existingDesign.all_items.forEach(function(existingItem) {
								if (existingItem.item_code === itemCode) {
									if (window._designFormSimpleModes[itemCode] === undefined) {
										window._designFormSimpleModes[itemCode] = existingItem.is_simple_mode !== undefined ? !!existingItem.is_simple_mode : true;
									}
								}
							});
						}

						if (window._designFormSimpleModes[itemCode] === undefined) {
							window._designFormSimpleModes[itemCode] = (itemCode === 'VP') ? false : true;
						}
						let isSimple = !!window._designFormSimpleModes[itemCode];

						let html = '';
						let artworkHtml = '';
						let artworkRenderCount = 0;

						html += `
						<div class="switch-container" style="margin-bottom: 15px;">
						  <label class="switch-text" for="cart-simple-mode-toggle-${itemCode}-${fillDesignFormIndexCheck}">Detailed</label>
						  <label class="switch">
							<input type="checkbox" id="cart-simple-mode-toggle-${itemCode}-${fillDesignFormIndexCheck}" class="cart-simple-mode-toggle-checkbox" data-item-code="${itemCode}" ${!isSimple ? 'checked' : ''}>
							<span class="slider"></span>
						  </label>
						</div>`;

						allItems.forEach((item, idx) => {
							const questions = (item.design_questions || []).concat(idx === 0 ? (item.questions || []) : []);

							let title = idx === 0 
								? (item.item_name || item.item_code || item.description)
								: (`${item.description || item.item_code} (x${item.qty || 1})`);

							const itemNameEscaped = title.replace(/"/g, '&quot;');
							const itemGroupEscaped = (item.item_group || "").replace(/"/g, '&quot;');
							const groupStart = `<div class="sidebar-design-item-edit-group" data-item-code="${item.item_code}" data-item-name="${itemNameEscaped}" data-item-group="${itemGroupEscaped}">`;

							const attachmentsHtml = `
								<div class="sidebar-design-edit-attachments" data-item-code="${item.item_code}">
								  <span class="sidebar-design-attach-label">Attachments:</span>
								  <div class="sidebar-design-edit-file-list"></div>
								  <button type="button" class="secondary-btn btn-xs sidebar-design-upload-btn" data-item-code="${item.item_code}">
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px;margin-right:3px"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
									Add File
								  </button>
								</div>
							`;

							const skipBasicDesign = isSimple && idx > 0;
							
							if (!skipBasicDesign) {
								html += groupStart;
								let labelAndBodyStart = '';
								if (allItems.length > 1) {
									labelAndBodyStart = `<div class="sidebar-design-item-label js-cart-item-accordion-toggle" style="cursor: pointer; display: flex; align-items: center; justify-content: space-between;">
									  ${title}
									  <svg class="js-cart-item-accordion-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0; margin-left: 8px; transition: transform 0.3s ease; transform: rotate(${idx === 0 ? '180deg' : '0deg'})">
										<polyline points="6 9 12 15 18 9"></polyline>
									  </svg>
									</div>
									<div class="sidebar-design-item-body" style="${idx > 0 ? 'display:none;' : ''}">`;
								} else {
									labelAndBodyStart = `<div class="sidebar-design-item-body">`;
								}
								html += labelAndBodyStart;

								if (window.DesignSidebarApi && typeof window.DesignSidebarApi.renderDesignElementsPanel === 'function') {
									const designElements = Array.isArray(item.design_form_elements) ? item.design_form_elements : [];
									if (designElements.length > 0) {
										html += window.DesignSidebarApi.renderDesignElementsPanel({
											title: title,
											itemCode: item.item_code,
											designElements: designElements,
											activeSizeOption: item.active_size_attribute_option || '',
											activeAttributeOptions: item.active_attribute_options || {},
										});
									}
								}

								if (isSimple) {
									html += `
									<div class="sidebar-design-qa-edit" data-item-code="${item.item_code}">
										<label class="sidebar-design-q-label">Enter your instructions</label>
										<textarea class="sidebar-design-a-input ds-simple-instructions-input" data-question="Enter your instructions" data-item-code="${item.item_code}" rows="4"></textarea>
									</div>
									`;
								} else {
									questions.forEach((q, qIdx) => {
										const qTitle = q.question || q.label || q.design_question;
										if (qTitle) {
											html += `
											<div class="sidebar-design-qa-edit" data-idx="${qIdx}" data-item-code="${item.item_code}">
												<label class="sidebar-design-q-label">${qTitle}</label>
												<textarea class="sidebar-design-a-input" data-question="${qTitle}" data-item-code="${item.item_code}" rows="2"></textarea>
											</div>
											`;
										}
									});
								}

								html += attachmentsHtml;
								html += `</div></div>`;
							}

							const hasTemplates = (item.product_templates && item.product_templates.length > 0) || (item.downloadable_templates && item.downloadable_templates.length > 0);
							const skipArtwork = (idx === 0 && item.item_code !== 'VP' && !hasTemplates);
							
							if (!skipArtwork) {
								artworkHtml += groupStart;
								let awLabelAndBodyStart = '';
								if (validArtworkItems.length > 1) {
									awLabelAndBodyStart = `<div class="sidebar-design-item-label js-cart-item-accordion-toggle" style="cursor: pointer; display: flex; align-items: center; justify-content: space-between;">
									  ${title}
									  <svg class="js-cart-item-accordion-icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0; margin-left: 8px; transition: transform 0.3s ease; transform: rotate(${artworkRenderCount === 0 ? '180deg' : '0deg'})">
										<polyline points="6 9 12 15 18 9"></polyline>
									  </svg>
									</div>
									<div class="sidebar-design-item-body" style="${artworkRenderCount > 0 ? 'display:none;' : ''}">`;
								} else {
									awLabelAndBodyStart = `<div class="sidebar-design-item-body">`;
								}
								artworkHtml += awLabelAndBodyStart;
								artworkHtml += attachmentsHtml;
								artworkHtml += `</div></div>`;
								artworkRenderCount++;
							}
						});

						// Action buttons
					const $fillBtn = $btn;
					const fillDesignFormIndex = parseInt($fillBtn.data("design-form-index") || 0, 10);
					const actionsHtml = `
						<div class="sidebar-design-edit-actions" style="margin-top:15px;">
						  <button type="button" class="sidebar-design-save-btn" data-item-code="${itemCode}" data-design-form-index="${fillDesignFormIndex}">Save</button>
						  <button type="button" class="sidebar-design-cancel-btn js-cancel-inline-design">Cancel</button>
						</div>
					`;
					html += actionsHtml;
					artworkHtml += actionsHtml;

					const savedMode = existingDesign ? existingDesign.design_mode : null;
					const savedBadgeHtml = `<span class="design-choice-submitted-badge"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-1px"><polyline points="20 6 9 17 4 12"></polyline></svg></span>`;

					let modeSelectorHtml = `
					<div class="design-choice-section mb-4">
					  <h6 style="font-weight:700; font-size:0.95rem; color:#0f172a; margin-bottom:14px;">
						Do you have artwork ready to upload or you want us to help with Design?
					  </h6>
					  <div class="design-choice-buttons">
						<button type="button" class="design-choice-btn cart-design-mode-btn${savedMode === 'artwork' ? ' submitted' : ''}" data-mode="artwork">
						  ${savedMode === 'artwork' ? savedBadgeHtml : ''}
						  <span class="design-choice-label">I Have Print Ready Files</span>
						  <span class="ds-info-trigger" onclick="event.stopPropagation()">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
							  <path d="M272 112C272 85.5 293.5 64 320 64C346.5 64 368 85.5 368 112C368 138.5 346.5 160 320 160C293.5 160 272 138.5 272 112zM224 256C224 238.3 238.3 224 256 224L320 224C337.7 224 352 238.3 352 256L352 512L384 512C401.7 512 416 526.3 416 544C416 561.7 401.7 576 384 576L256 576C238.3 576 224 561.7 224 544C224 526.3 238.3 512 256 512L288 512L288 288L256 288C238.3 288 224 273.7 224 256z" />
							</svg>
						  </span>
						</button>
						<button type="button" class="design-choice-btn cart-design-mode-btn${savedMode === 'basic_design' ? ' submitted' : (!savedMode ? ' active' : '')}" data-mode="basic_design">
						  ${savedMode === 'basic_design' ? savedBadgeHtml : ''}
						  <span class="design-choice-label">I need a basic design</span>
						  <span class="design-choice-badge">Most Common</span>
						  <span class="ds-info-trigger" onclick="event.stopPropagation()">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
							  <path d="M272 112C272 85.5 293.5 64 320 64C346.5 64 368 85.5 368 112C368 138.5 346.5 160 320 160C293.5 160 272 138.5 272 112zM224 256C224 238.3 238.3 224 256 224L320 224C337.7 224 352 238.3 352 256L352 512L384 512C401.7 512 416 526.3 416 544C416 561.7 401.7 576 384 576L256 576C238.3 576 224 561.7 224 544C224 526.3 238.3 512 256 512L288 512L288 288L256 288C238.3 288 224 273.7 224 256z" />
							</svg>
						  </span>
						</button>
						<button type="button" class="design-choice-btn cart-design-mode-btn${savedMode === 'custom_quote' ? ' submitted' : ''}" data-mode="custom_quote">
						  ${savedMode === 'custom_quote' ? savedBadgeHtml : ''}
						  <span class="design-choice-label">I need a custom quote</span>
						  <span class="ds-info-trigger" onclick="event.stopPropagation()">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
							  <path d="M272 112C272 85.5 293.5 64 320 64C346.5 64 368 85.5 368 112C368 138.5 346.5 160 320 160C293.5 160 272 138.5 272 112zM224 256C224 238.3 238.3 224 256 224L320 224C337.7 224 352 238.3 352 256L352 512L384 512C401.7 512 416 526.3 416 544C416 561.7 401.7 576 384 576L256 576C238.3 576 224 561.7 224 544C224 526.3 238.3 512 256 512L288 512L288 288L256 288C238.3 288 224 273.7 224 256z" />
							</svg>
						  </span>
						</button>
					  </div>
					</div>
					`;

					const fullHtml = modeSelectorHtml + `<div class="cart-inline-form-container" data-item-code="${itemCode}" data-design-form-index="${fillDesignFormIndex}">${html}</div>`;

					$container.html(fullHtml);
					$container.find('.cart-inline-form-container').data('basic-design-html', html);
					$container.find('.cart-inline-form-container').data('artwork-html', artworkHtml);

					if (window.DesignSidebarApi && typeof window.DesignSidebarApi.initAccordions === 'function') {
						window.DesignSidebarApi.initAccordions($container.find('.cart-inline-form-container')[0]);
					}

					// Initialize state for the default mode (basic_design)
					if (!window._designSidebar) window._designSidebar = {};
					window._designSidebar.mode = 'basic_design';
					window._designSidebar.designFormIndex = fillDesignFormIndex;

					$container.find('.cart-design-mode-btn').on('click', function() {
						const $thisBtn = $(this);
						const mode = $thisBtn.data('mode');
						
						$container.find('.cart-design-mode-btn').removeClass('active');
						$thisBtn.addClass('active');

						if (window._designSidebar) {
							window._designSidebar.mode = mode;
							window._designSidebar.designFormIndex = fillDesignFormIndex;
						}

						const $formContainer = $container.find('.cart-inline-form-container');
						
						if (mode === 'basic_design') {
							$formContainer.html($formContainer.data('basic-design-html'));
							if (window.DesignSidebarApi && typeof window.DesignSidebarApi.initAccordions === 'function') {
								window.DesignSidebarApi.initAccordions($formContainer[0]);
							}
							$formContainer.find('.js-cancel-inline-design').on('click', function () {
								$container.hide();
								if (isEdit) {
									$viewMode.show();
								} else {
									$emptyState.show();
								}
							});
						} else if (mode === 'artwork') {
							$formContainer.html($formContainer.data('artwork-html'));
							$formContainer.find('.js-cancel-inline-design').on('click', function () {
								$container.hide();
								if (isEdit) {
									$viewMode.show();
								} else {
									$emptyState.show();
								}
							});
						} else if (mode === 'custom_quote') {
							if (window.DesignSidebarApi && window.DesignSidebarApi.loadCustomQuoteMode) {
								window.DesignSidebarApi.loadCustomQuoteMode($formContainer[0], itemCode, {includeSubmit: true});
							}
						}
					});

					$emptyState.hide();
					$container.show();
					if (!isEdit) {
						$btn.prop("disabled", false).text("Fill Design Form");
					} else {
						$btn.prop("disabled", false);
					}

					// Attach cancel
					$container.find('.js-cancel-inline-design').on('click', function () {
						$container.hide();
						if (isEdit) {
							$viewMode.show();
						} else {
							$emptyState.show();
						}
					});
					
					// Pre-populate if editing
					if (existingDesign) {
						let modeToClick = 'basic_design';
						if (existingDesign.design_mode === 'artwork') modeToClick = 'artwork';
						if (existingDesign.design_mode === 'custom_quote') modeToClick = 'custom_quote';
						$container.find(`.cart-design-mode-btn[data-mode="${modeToClick}"]`).click();

						if (existingDesign.all_items) {
							existingDesign.all_items.forEach(function(existingItem) {
								if (existingItem.is_simple_mode) {
									const $ta = $container.find(`textarea.ds-simple-instructions-input[data-item-code="${existingItem.item_code}"]`);
									if ($ta.length) $ta.val(existingItem.simple_instructions || '');
								}
								if (existingItem.questions_answers) {
									existingItem.questions_answers.forEach(function(qa) {
										const $ta = $container.find(`textarea.sidebar-design-a-input[data-item-code="${existingItem.item_code}"][data-question="${qa.question.replace(/"/g, '\\"')}"]`);
										if ($ta.length) $ta.val(qa.answer || '');
									});
								}
								if (existingItem.attachments) {
									const $fileList = $container.find(`.sidebar-design-edit-attachments[data-item-code="${existingItem.item_code}"] .sidebar-design-edit-file-list`);
									if ($fileList.length) {
										existingItem.attachments.forEach(function(url) {
											const fileName = url.split('/').pop();
											const fileHtml = `
												<div class="sidebar-design-edit-file" data-url="${url}">
													<a href="${url}" target="_blank" class="sidebar-design-attach-link" title="${fileName}">${fileName}</a>
													<button type="button" class="sidebar-design-edit-file-remove" data-url="${url}" title="Remove">&times;</button>
												</div>
											`;
											$fileList.append(fileHtml);
										});
									}
								}
							});
						} else if (existingDesign.questions_answers) {
							// fallback for older records
							existingDesign.questions_answers.forEach(function(qa) {
								const $ta = $container.find(`textarea.sidebar-design-a-input[data-question="${qa.question.replace(/"/g, '\\"')}"]`);
								if ($ta.length) $ta.val(qa.answer || '');
							});
							if (existingDesign.attachments) {
								const $fileList = $container.find('.sidebar-design-edit-file-list');
								existingDesign.attachments.forEach(function(url) {
									const fileName = url.split('/').pop();
									const fileHtml = `
										<div class="sidebar-design-edit-file" data-url="${url}">
											<a href="${url}" target="_blank" class="sidebar-design-attach-link" title="${fileName}">${fileName}</a>
											<button type="button" class="sidebar-design-edit-file-remove" data-url="${url}" title="Remove">&times;</button>
										</div>
									`;
									$fileList.append(fileHtml);
								});
							}
						}
					}

					} else {
						$container.html('<div class="alert alert-danger">Error loading design form. Please try again.</div>');
						if (!isEdit) $btn.prop("disabled", false).text("Fill Design Form");
					}
				},
				error: function () {
					$container.html('<div class="alert alert-danger">Error loading design form. Please try again.</div>');
					if (!isEdit) $btn.prop("disabled", false).text("Fill Design Form");
				}
			});
		});

		// Simple Mode Toggle Checkbox
		$(document).on("change", ".cart-simple-mode-toggle-checkbox", function () {
			const item_code = $(this).data('item-code');
			const checked = $(this).is(':checked');
			window._designFormSimpleModes = window._designFormSimpleModes || {};
			window._designFormSimpleModes[item_code] = !checked;

			// Re-trigger click to re-render
			const $container = $(this).closest('.cart-inline-form-container');
			const $btn = $container.closest('.sidebar-design-accordion').find('.sidebar-design-edit-btn');
			if ($btn.length) {
				$btn.click();
			} else {
				// fallback for fill design form button
				$container.closest('.sidebar-design-accordion-body').find('.js-open-cart-design-form').click();
			}
		});

		// Cart Item Accordion Toggle
		$(document).on("click", ".js-cart-item-accordion-toggle", function () {
			const $toggle = $(this);
			const $group = $toggle.closest(".sidebar-design-item-group, .sidebar-design-item-edit-group");
			const $body = $group.find(".sidebar-design-item-body").first();
			const $icon = $toggle.find(".js-cart-item-accordion-icon");

			// If closing
			if ($body.is(":visible")) {
				$body.slideUp();
				$icon.css("transform", "rotate(0deg)");
			} else {
				// Close others in the same container
				const $container = $group.closest(".sidebar-design-accordion-body");
				if ($container.length) {
					$container.find(".sidebar-design-item-body").slideUp();
					$container.find(".js-cart-item-accordion-icon").css("transform", "rotate(0deg)");
				}

				$body.slideDown();
				$icon.css("transform", "rotate(180deg)");
			}
		});


		$(document).on("mousedown", ".sidebar-qty-btn, .sidebar-remove-product", function () {
			shopping_cart._sidebar_skip_blur_once = true;
			setTimeout(function () {
				shopping_cart._sidebar_skip_blur_once = false;
			}, 150);
		});

		$(document).on("click", ".sidebar-qty-btn", function () {
			const $btn = $(this);
			const $item = $btn.closest(".sidebar-cart-item");
			const $input = $btn.siblings(".sidebar-qty-input");
			const itemCode = ($item.attr("data-item-code") || $input.attr("data-item-code") || "").trim();
			const designFormIndex = $item.attr("data-design-form-index") || 0;
			if (!itemCode) return;
			let value = parseInt($input.val(), 10);
			value = Number.isNaN(value) ? 1 : value;

			if ($btn.data("dir") === "up") {
				value += 1;
			} else {
				value = value <= 1 ? 0 : value - 1;
			}

			if (value === 0) {
				const $removeBtn = $item.find(".sidebar-remove-product");
				if ($removeBtn.length) {
					$removeBtn.trigger("click");
					return;
				}
			}

			const $qtySelector = $btn.closest(".sidebar-qty-selector");
			if ($qtySelector.length) $qtySelector.addClass("throbber");
			else $btn.addClass("throbber");

			shopping_cart.sidebar_update_item_qty(itemCode, value, null, designFormIndex);
		});

		$(document).on("focus", ".sidebar-qty-input", function () {
			$(this).select();
		});

		$(document).on("keydown", ".sidebar-qty-input", function (e) {
			if (e.key === "Enter") {
				e.preventDefault();
				$(this).trigger("blur");
			}
		});

		$(document).on("blur", ".sidebar-qty-input", function () {
			if (shopping_cart._sidebar_skip_blur_once) {
				return;
			}

			const $input = $(this);
			const $item = $input.closest(".sidebar-cart-item");
			const itemCode = ($item.attr("data-item-code") || $input.attr("data-item-code") || "").trim();
			const designFormIndex = $item.attr("data-design-form-index") || 0;
			if (!itemCode) return;
			let value = parseInt($input.val(), 10);

			if (Number.isNaN(value) || value < 1) {
				value = 1;
			}

			const $qtySelector = $input.closest(".sidebar-qty-selector");
			if ($qtySelector.length) $qtySelector.addClass("throbber");
			else $input.addClass("throbber");

			shopping_cart.sidebar_update_item_qty(itemCode, value, null, designFormIndex);
		});

		$(document).on("click", ".sidebar-remove-product", function () {
			const $btn = $(this);
			$btn.addClass("throbber");
			const $item = $btn.closest(".sidebar-cart-item");
			const itemCode = ($item.attr("data-item-code") || $btn.attr("data-item-code") || "").trim();
			const designFormIndex = $item.attr("data-design-form-index") || 0;
			if (!itemCode) {
				$btn.removeClass("throbber");
				return;
			}

			// Determine codes to remove (main + addons)
			let codesToRemove = [itemCode];
			let isMain = !$item.hasClass("sidebar-cart-item-addon");
			let addonCodes = [];
			const $group = $item.closest(".sidebar-cart-group");

			if (isMain) {
				$group.find(".sidebar-cart-item-addon").each(function () {
					const code = (($(this).attr("data-item-code") || "").trim());
					if (code) addonCodes.push(code);
				});
				if (addonCodes.length) codesToRemove = [itemCode].concat(addonCodes);
			}

			// Collect design response names for these codes (if any)
			const responses = [];
			codesToRemove.forEach(function (code) {
				const $acc = $group.find(".sidebar-design-accordion[data-item-code='" + code + "']");
				if ($acc.length) {
					$acc.each(function() {
						const resp = $(this).attr("data-response-name");
						if (resp) responses.push({ item_code: code, response_name: resp });
					});
				}
			});

			if (responses.length) {
				const msg = responses.length === 1
					? __("Removing this item will delete its saved design form. Continue?")
					: __("Removing this item (and its addons) will delete {0} saved design form(s). Continue?", [String(responses.length)]);

				shopping_cart.show_custom_confirm(
					__("Confirm Removal"),
					msg,
					[
						{ text: __("Cancel"), value: false, primary: false },
						{ text: __("Continue"), value: true, primary: true }
					]
				).then(function (confirmed) {
					if (!confirmed) {
						$btn.removeClass("throbber");
						return;
					}
					// Delete each design response first
					const deletePromises = responses.map(function (r) {
						return new Promise(function (resolve) {
							frappe.call({
								type: "POST",
								method: "klaviyo_integration.www.design_form.index.delete_design_response",
								args: { response_name: r.response_name, item_code: r.item_code, design_form_index: designFormIndex },
								callback: function (res) {
									resolve(res);
								},
								error: function (err) {
									resolve({ message: { status: 'error', error: err } });
								}
							});
						});
					});

					Promise.all(deletePromises).then(function (results) {
						const failed = results.find(function (res) { return !(res && res.message && res.message.status === 'success'); });
						if (failed) {
							frappe.msgprint({ title: __('Error'), message: __('Failed to delete design form(s). Please try again.'), indicator: 'red' });
							$btn.removeClass("throbber");
							return;
						}

						// Clear local sidebar caches for affected items (best-effort)
						try {
							responses.forEach(function (r) {
								localStorage.removeItem('ds_form_cache_basic_design_' + r.item_code);
								localStorage.removeItem('ds_form_cache_artwork_' + r.item_code);
								localStorage.removeItem('ds_files_basic_design_' + r.item_code);
								localStorage.removeItem('ds_files_artwork_' + r.item_code);
							});
						} catch (e) { }

						// Proceed with removal
						if (isMain && addonCodes.length) {
							shopping_cart.sidebar_remove_with_addons(itemCode, addonCodes, designFormIndex);
						} else {
							shopping_cart.sidebar_update_item_qty(itemCode, 0, null, designFormIndex);
						}
					});
				});
				return;
			}

			// no design responses, proceed normally
			if (isMain && addonCodes.length) {
				shopping_cart.sidebar_remove_with_addons(itemCode, addonCodes, designFormIndex);
			} else {
				shopping_cart.sidebar_update_item_qty(itemCode, 0, null, designFormIndex);
			}
		});

		$(document).on("click", ".sidebar-edit-options", function () {
			const itemCode = $(this).data("item-code");
			frappe.call({
				method: "klaviyo_integration.www.checkout.index.get_edit_options_url",
				args: { item_code: itemCode },
				callback: function (r) {
					if (r.message) {
						window.location.href = r.message;
					}
				}
			});
		});

		$(document).on("click", "#sidebar-checkout-btn", function () {
			window.location.href = "/checkout";
		});

		$(document).on("click", ".sidebar-bt-coupon", function () {
			shopping_cart.sidebar_apply_coupon_code(this);
		});

		$(document).on("keydown", ".sidebar-txtcoupon", function (e) {
			if (e.key === "Enter") {
				e.preventDefault();
				const $btn = $(this).siblings(".sidebar-bt-coupon");
				if ($btn.length) {
					$btn.trigger("click");
				}
			}
		});

		$(document).on("click", ".sidebar-bt-remove-coupon-code", function () {
			shopping_cart.sidebar_remove_coupon_code(this);
		});
	},

	sidebar_apply_coupon_code(btn) {
		const appliedCode = ($(".sidebar-txtcoupon").val() || "").trim();
		if (!appliedCode) {
			frappe.msgprint(__("Please enter a coupon code"));
			return;
		}

		const referralSalesPartner = frappe.get_cookie("referral_sales_partner") || "";
		return frappe.call({
			type: "POST",
			method: "klaviyo_integration.apis.cart_coupon.apply_coupon_code",
			btn,
			args: {
				applied_code: appliedCode,
				applied_referral_sales_partner: referralSalesPartner
			},
			callback: function (r) {
				if (r && r.message) {
					shopping_cart.set_cart_count(true);
					shopping_cart.refresh_cart_sidebar();
				}
			}
		});
	},

	sidebar_remove_coupon_code(btn) {
		const appliedCode = ($(btn).data("coupon-code") || "").trim();
		return frappe.call({
			type: "POST",
			method: "klaviyo_integration.apis.cart_coupon.remove_coupon_code",
			btn,
			args: {
				applied_code: appliedCode || undefined
			},
			callback: function (r) {
				if (r && r.message) {
					shopping_cart.set_cart_count(true);
					shopping_cart.refresh_cart_sidebar();
				}
			}
		});
	},

	sidebar_remove_with_addons(mainItemCode, addonCodes, designFormIndex = 0) {
		if (!frappe.session.user || frappe.session.user === "Guest") {
			window.location.href = "/login?redirect_to=/cart";
			return;
		}

		shopping_cart.freeze();
		const allCodes = addonCodes.concat([mainItemCode]);

		const removeSequentially = (codes, index) => {
			if (index >= codes.length) {
				shopping_cart.set_cart_count(true);
				shopping_cart.refresh_cart_sidebar();
				return;
			}
			frappe.call({
				type: "POST",
				method: "webshop.webshop.shopping_cart.cart.update_cart",
				args: { item_code: codes[index], qty: 0, with_items: 1, design_form_index: codes[index] === mainItemCode ? designFormIndex : 0 },
				callback: function (r) {
					if (r.exc) {
						shopping_cart.unfreeze();
						frappe.msgprint(__("Unable to remove cart item right now."));
						return;
					}
					removeSequentially(codes, index + 1);
				}
			});
		};

		removeSequentially(allCodes, 0);
	},

	sidebar_update_item_qty(itemCode, qty, freezeMessage, designFormIndex = 0) {
		if (!frappe.session.user || frappe.session.user === "Guest") {
			window.location.href = "/login?redirect_to=/cart";
			return;
		}

		shopping_cart.freeze();
		shopping_cart.update_cart({
			item_code: itemCode,
			qty: qty,
			with_items: 1,
			design_form_index: designFormIndex,
			callback: function (r) {
				if (!r.exc) {
					shopping_cart.set_cart_count(true);
					shopping_cart.refresh_cart_sidebar();
					return;
				}

				shopping_cart.unfreeze();
				frappe.msgprint(__("Unable to update cart item right now."));
			}
		});
	},

	ensure_cart_sidebar_dom() {
		if ($("#cart-drawer-backdrop").length && $("#cart-drawer").length) {
			return;
		}

		$("body").append(`
			<div id="cart-drawer-backdrop" aria-hidden="true"></div>
			<aside id="cart-drawer" role="dialog" aria-modal="true" aria-label="Shopping cart">
				<div id="cart-drawer-content"></div>
			</aside>
		`);
	},

	open_cart_sidebar(triggerEl) {
		shopping_cart.ensure_cart_sidebar_dom();
		$("#cart-drawer-content").html('<div class="sidebar-cart-loading">Loading cart...</div>');

		if (triggerEl) {
			const $trigger = $(triggerEl);
			$trigger.attr("aria-expanded", "true");
		}

		$("body").addClass("cart-drawer-open");
		shopping_cart.refresh_cart_sidebar();
	},

	close_cart_sidebar() {
		$("body").removeClass("cart-drawer-open");
		$("[data-cart-sidebar-trigger]").attr("aria-expanded", "false");
	},

	refresh_cart_sidebar() {
		frappe.call({
			method: "klaviyo_integration.www.cart.index.get_sidebar_cart_html",
			callback: function (r) {
				if (r.message && r.message.html) {
					document.dispatchEvent(new CustomEvent("cart:active-changed"));
					$("#cart-drawer-content").html(r.message.html);
					shopping_cart.apply_sidebar_price_formatting();
					shopping_cart.refresh_navbar_cart_value();

					if ($("#cart-drawer-content .sidebar-address-warning").length) {
						shopping_cart.sync_preferred_addresses_to_cart();
					}

					return;
				}

				shopping_cart.close_cart_sidebar();
				window.location.href = "/cart";
			},
			error: function () {
				shopping_cart.close_cart_sidebar();
				window.location.href = "/cart";
			}
		});
	},

	apply_sidebar_price_formatting() {
		const currency = $(".sidebar-cart-root").data("currency") || "USD";
		document.querySelectorAll(".js-sidebar-price[data-amount]").forEach((el) => {
			const amount = Number(el.dataset.amount);
			if (Number.isNaN(amount)) return;
			el.textContent = shopping_cart.format_price(amount, currency);
		});
	},

	refresh_navbar_cart_value() {
		frappe.call({
			method: "webshop.webshop.shopping_cart.cart.get_cart_quotation",
			callback: function (r) {
				if (!(r.message && r.message.doc)) return;

				const amount = Number(r.message.doc.grand_total || 0);
				const currency = r.message.doc.currency || "USD";
				document.querySelectorAll(".js-cart-value").forEach((el) => {
					el.textContent = shopping_cart.format_price(amount, currency);
				});
			}
		});
	},

	format_price(amount, currency) {
		return new Intl.NumberFormat("en-US", {
			style: "currency",
			currency: currency || "USD",
			minimumFractionDigits: 2
		})
			.format(amount)
			.replace(/^(\D+)/, "$1\u00A0")
			.replace(/[ \t\r\n\f\v]+/, " ");
	},

	get_active_sidebar_cart_name() {
		return (($(".sidebar-cart-root").attr("data-active-cart-name") || "") + "").trim();
	},

	sidebar_switch_cart(quotationName) {
		return frappe.call({
			type: "POST",
			method: "klaviyo_integration.apis.multi_cart.set_active_cart",
			args: { quotation_name: quotationName },
			callback: function (r) {
				if (r && !r.exc) {
					shopping_cart.set_cart_count(true);
					shopping_cart.refresh_cart_sidebar();
				}
			}
		});
	},

	sidebar_create_cart(cartName) {
		return frappe.call({
			type: "POST",
			method: "klaviyo_integration.apis.multi_cart.create_cart",
			args: { cart_name: cartName || undefined },
			callback: function (r) {
				if (r && !r.exc) {
					const activeName = (((r.message || {}).active_cart_name || "") + "").trim();
				}
			}
		});
	},

	sidebar_rename_cart(quotationName, cartName) {
		if (!cartName) {
			frappe.msgprint(__("Cart name cannot be empty"));
			return;
		}

		return frappe.call({
			type: "POST",
			method: "klaviyo_integration.apis.multi_cart.rename_cart",
			args: {
				quotation_name: quotationName,
				cart_name: cartName
			},
			callback: function (r) {
				if (r && !r.exc) {
					shopping_cart.refresh_cart_sidebar();
				}
			}
		});
	},

	sidebar_delete_cart(quotationName) {
		return frappe.call({
			type: "POST",
			method: "klaviyo_integration.apis.multi_cart.delete_cart",
			args: { quotation_name: quotationName },
			callback: function (r) {
				if (r && !r.exc) {
					shopping_cart.set_cart_count(true);
					shopping_cart.refresh_cart_sidebar();
				}
			}
		});
	},
});
